import React from 'react';
import {
  Heading,
} from '@americanexpress/dls-react';

/* istanbul ignore next */
function CommonError() {
  return (
    <main>
      <div className="dls-gray-01-bg pad">
        <div id="alert-component" className="alert alert-neutral alert-null alert-dialog " role="alert">
          <div className="col-md-12">
            <div className="pad-2-tb">
              <div className="text-align-center">
                <div>
                  <Heading
                    headingStyle="heading4"
                    level={1}
                  >
                    <div style={{
                      fontFamily: 'BentonSans-Md',
                      fontWeight: 600,
                      fontSize: '25px',
                      lineHeight: '1.375rem',
                      color: '#003677',
                      textAlign: 'center',
                    }}
                    >This page is not found.
                    </div>

                  </Heading>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default CommonError;
